module.exports = __webpack_public_path__ + "static/media/esa.7b578888.png";